import { render, staticRenderFns } from "./Epq.vue?vue&type=template&id=530df5a7"
import script from "./Epq.vue?vue&type=script&lang=js"
export * from "./Epq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports